import styled from 'styled-components';
import CustomScrollbar from '../../../../../CustomScrollbar';

export const Container = styled(CustomScrollbar)<{
  isShowScroll: boolean;
  isMobile: boolean;
}>`
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
  max-height: ${({ isShowScroll, isMobile }) =>
    isShowScroll && !isMobile ? '340px' : 'none'};
  overflow-y: ${({ isMobile }) => isMobile && 'visible'};
`;
